import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import {
  DataResponse,
  SalesForceIntegrationModels,
  SalesForceModelMapResponseDataSchema,
  SalesForceModelsRespnseDataSchema,
} from "schema"
import { z } from "zod"

type ObjectResponse = DataResponse<z.infer<typeof SalesForceModelMapResponseDataSchema>>
type ModelsResponse = DataResponse<z.infer<typeof SalesForceModelsRespnseDataSchema>>

export const queryKey = ["salesForceModelMap"]

export const salesForceModelMapQuery = ({
  model,
}: {
  model: z.infer<typeof SalesForceIntegrationModels>
}) => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const object = await axios.get<ObjectResponse>(`/integrations/salesForce/objects/${model}`)
      const models = await axios.get<ModelsResponse>(`/integrations/salesForce/objects`)

      return { object: object.data.data, model: models.data.data.find((e) => e.name === model) }
    },
  })
}
